import { User } from '@sdk/users/types/User';

export const isInactiveUser = (user: User) => {
  return Boolean(user && (user.deleted || !user.isActive));
};
